module.exports = __webpack_public_path__ + "media/images/empty/review-4eaf54db60a694a61e37ab96e9e98a4d.svg";